import { transformPermission } from '@/helpers/data-transform';
import * as types from '../mutation-types'
import { actionType, defaultPermissions } from '@/helpers/enums';

const fillPermissions = (fillTrue) => {
	return defaultPermissions.reduce((res, a) => {
		res[a.key] = !fillTrue ? {} : { isAllowed: true, isReadonly: false, isNone: false };
		return res;
	}, {})
}

export default {
	namespaced: true,
	state: {
		authenticated: false,
		self: {
			id: null,
			name: null, 
			username: null, 
			isAdmin: null
		},
		permissionsForUser: {},
		selfPermissions: fillPermissions()

	},
	actions: {
		login({ commit }, { username, password, preventSaveAuth }) {
			return axios.post('/Users/Login', {
				username,
				password
			}, {
				preventErrorHandler: preventSaveAuth
			}).then((response) => {
				if (!preventSaveAuth) {
					const auth = {
						id: response.data.userId,
						name: response.data.username, 
						username: response.data.username, 
						token: response.data.token,
						isAdmin: response.data.isAdmin
					};
					localStorage.setItem('auth', JSON.stringify(auth));
					window.axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.token;
					commit(types.LOGIN, auth);
				}
				return response.data
			})
		},

		logout({ commit }) {
			localStorage.removeItem('auth');
			localStorage.removeItem('userType');
			localStorage.removeItem('isAdmin');
			delete window.axios.defaults.headers.common.authenticated;
			commit(types.LOGOUT)
		},

		fetchPermissionsForUserLogin({ commit }, { storeId }) {
			return axios.get(`Users/Self/Permissions/${storeId}`).then(({ data }) => {
				commit(types.STORE_PERMISSIONS_FOR_USER, data);
				return data
			})
		},

		fetchSelfPermissions({ commit }, { storeId }) {
			return axios.get(`/users/self/role/${storeId}`).then(({ data }) => {
				const transformedPermissions = transformPermission(data.rules);
				commit(types.STORE_SELF_PERMISSIONS, transformedPermissions);
				return { ...data.permission, permissions: transformedPermissions }
			})
		},

		reset({ commit }) {
			return commit(types.RESET)
		}
	},
	mutations: {
		[types.LOGIN](state, auth) {
			state.authenticated = true;
			state.self.id = auth.id;
			state.self.name = auth.name;
			state.self.username = auth.name;
			state.self.isAdmin = auth.isAdmin;
			if (auth.isAdmin) state.selfPermissions = fillPermissions(true);
		},
		
		[types.LOGOUT](state) {
			state.authenticated = false;
			state.self.id = null;
			state.self.name = null
			state.self.username = null
			state.self.token = null;
			state.self.isAdmin = false
		},

		[types.STORE_PERMISSIONS_FOR_USER](state, permissionsForUser) {
			state.permissionsForUser = permissionsForUser;
		},
		
		[types.STORE_SELF_PERMISSIONS](state, selfPermissions) {
			const tempPermissions = {};
			const permissionsKeys = defaultPermissions.map(c => ({
				key: c.key, permissionType: c.permissionType
			}));

			// managingProductionOrders
			permissionsKeys.forEach(c => {
				const obj = selfPermissions.find(e => e.permissionType === c.permissionType);
				tempPermissions[c.key] = {
					isAllowed: obj ? obj.value === actionType.readAndWrite : false,
					isReadonly: obj ? obj.value === actionType.read : false,
					isNone: obj ? obj.value === actionType.none : true,
				}
			});

			state.selfPermissions = tempPermissions;
		},

		[types.RESET](state) {
			state.permissionsForUser = {};
			state.selfPermissions = fillPermissions();
		},
	}
}